import { AnnouncementTypes } from '../announcement-types';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnnouncementsService } from '../announcements.service';
import { Component, OnInit, Input } from '@angular/core';
import { Announcement } from '../announcement';

@Component({
  selector: 'wsg-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.css']
})
export class AnnouncementsComponent implements OnInit {

  size = 40;
  alternate = true;
  announcements: Announcement[];
  @Input() type = '';

  constructor(private announcementsService: AnnouncementsService, private snackbar: MatSnackBar) { }

  ngOnInit() {
    this.getAnnouncements();
  }

  getAnnouncements() {
    this.announcementsService.get(this.type)
                             .subscribe(announcements => {
                               this.announcements = announcements;
                             }, error => {
                              this.snackbar.open('Error retrieving announcements', 'DISMISS', { duration: 2000 });
                             });
  }
}
